import React, { useState, useEffect, useMemo, } from 'react';
import clsx from 'clsx';
import {
    MatchQuestion,
    BlankQuestion,
    IconButton,
    ProgressBar,
    ArrangeQuestion,
    MultipleChoicesQuestion,
    CrosswordQuestion,
    FireworksEffect,
} from '~/components';
import styles from './Exercise.module.scss';

import { useLocation, useNavigate } from 'react-router-dom';
import useSound from 'use-sound';
import audioRight from '~/assets/right.mp3';
import audioWrong from '~/assets/wrong.mp3';
import audioNormal from '~/assets/normal.mp3';
import audioSummary from '~/assets/summary.mp3';
import { calcQuantityOfQuestion, processStringToKey, processStringToKeyList, shuffleArray } from '~/utils/common';
import quizApi from '~/api/quizApi';
import { toast } from 'react-toastify';
import { BarLoader } from 'react-spinners';
import Countdown from 'react-countdown';
import { checkIsImportant, getConfigForTest, getGPLXCode, getTimeForTest } from '~/utils/600bca';
// npm install react-countdown --legacy-peer-deps

const getAudioUrls = (audioMap, keys) => {
    return keys.map(key => audioMap[key]);

}



function Exercise() {
    const [first, setFirst] = useState(true);
    const query = useQuery();
    const lessonId = query.get('lesson');
    const exerciseId = query.get('id');
    const bookId = '600bca'; //query.get('book');

    const isTest = bookId === '600bca' && lessonId === "random" && exerciseId === "test";
    const [targetTime] = useState(() =>
        Date.now() + getTimeForTest() * 60 * 1000
        // Date.now() + 5000
    );
    const gplxCode = getGPLXCode();
    const [playAudioSummary] = useSound(audioSummary);
    const [playAudioRight] = useSound(audioRight);
    const [playAudioWrong] = useSound(audioWrong);
    const [playAudioNormal] = useSound(audioNormal);

    const [questions, setQuestions] = useState([]);
    const [audioMap, setAudioMap] = useState({});

    const [streak, setStreak] = useState(0);
    const [current, setCurrent] = useState(0);
    const [numberAll, setNumberAll] = useState(0);
    const [numberAllOrigin, setNumberAllOrigin] = useState(0);
    const [numberSpent, setNumberSpent] = useState(0);
    const [numberCorrect, setNumberCorrect] = useState(0);
    const [important, setImportant] = useState({ spent: 0, wrong: 0 });
    const [testResult, setTestResult] = useState("UNKNOWN");
    const [timeDone, setTimeDone] = useState(false);

    const navigate = useNavigate();

    // Tạo một đối tượng Audio duy nhất
    const audioPlayer = useMemo(() => new Audio(), []);
    const [isPlayingSeries, setIsPlayingSeries] = useState(false);
    const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
    const [urls, setUrls] = useState([]);

    const handleStop = () => {
        setIsPlayingSeries(false)
        audioPlayer.pause();
    };

    const handlePlay = (text) => {
        const src = audioMap[processStringToKey(text)];
        handleStop();
        audioPlayer.src = src;
        audioPlayer.play().catch(error => { });
    };

    const handlePlayByWords = (text) => {
        setUrls(getAudioUrls(audioMap, processStringToKeyList(text)));
        handleStop();
        setIsPlayingSeries(true);
        setCurrentAudioIndex(0);
        playSequentialAudios();
    };

    const playSequentialAudios = () => {
        if (!urls || urls.length === 0) return;

        audioPlayer.src = urls[currentAudioIndex]

        // Khi audio hiện tại kết thúc, chuyển sang audio tiếp theo
        audioPlayer.onended = () => {
            if (currentAudioIndex < urls.length - 1) {
                setTimeout(() => {
                    setCurrentAudioIndex(prev => prev + 1);
                }, 500);
            } else {
                handleStop()
            }
        };

        // Phát audio hiện tại
        audioPlayer.play().catch(error => { });
    };

    useEffect(() => {
        // console.log('currentAudioIndex', currentAudioIndex, isPlayingSeries)
        if (isPlayingSeries) {
            playSequentialAudios();
        }
        // eslint-disable-next-line
    }, [currentAudioIndex, isPlayingSeries]);

    useEffect(() => {
        if (current === numberAllOrigin && current !== 0) {
            toast.success('Sửa những lỗi đã làm sai nào!!!');
        }
    }, [current, numberAllOrigin]);

    useEffect(() => {
        // console.log('important', important)
        if (important.wrong > 0) {
            toast.error('SAI CÂU ĐIỂM LIỆT RỒI!!!');
        }
    }, [important.wrong]);

    useEffect(() => {
        // console.log('isTest', isTest)
        // console.log('numberCorrect', numberCorrect)
        // console.log('important', important)
        // vanlh1
        if (isTest) {
            if (important.wrong > 0) {
                if (testResult === 'UNKNOWN') {
                    setTestResult('FAIL');
                }
            }
            if (important.spent > 0 && important.wrong === 0 && numberCorrect >= getConfigForTest(gplxCode).min) {
                if (testResult === 'UNKNOWN') {
                    setTestResult('PASS');
                }
            }

        }
    }, [isTest, numberCorrect, important]);

    const showSummary = (all, right) => {
        playAudioSummary();
        if (isTest)
            navigate(
                `/summary?book=${bookId}&lesson=${lessonId}&all=${all}&correct=${right}&test=${testResult}`,
            );
        else
            navigate(
                `/summary?book=${bookId}&lesson=${lessonId}&all=${all}&correct=${right}`,
            );
    };

    function updateResult(kq, isContinue) {

        if (isContinue) handleContinue(kq);
    }

    function handleContinue(kq) {
        let willAdd = kq.count !== kq.correct;
        if (isTest)
            willAdd = false;
        if (willAdd) {
            setQuestions([...questions, { ...questions[current] }]);
        }
        const newLength = questions.length + (willAdd ? 1 : 0);
        if (current < newLength - 1) {
            // vẫn còn câu hỏi
            setCurrent((prevCurrent) => {
                if (prevCurrent < newLength - 1) return prevCurrent + 1;
                return prevCurrent;
            });
        } else {
            // đã hết câu hỏi
            showSummary(numberSpent, numberCorrect);
        }
    }

    function notiCompleteAnAnswer(type, kq, isContinue) {
        let newStreak = -1;
        if (kq.count !== kq.correct) { // tức SAI
            newStreak = 0;
        } else {
            newStreak = streak + kq.correct;
        }
        if ((newStreak === 5 || newStreak === 10) && !isTest) {
            toast.success(`Chúc mừng đúng ${newStreak} liên tiếp`);
        }
        setStreak(newStreak);
        // console.log('current', current)
        // console.log('numberAllOrigin', numberAllOrigin)
        // cập nhật số lượng câu đã làm và đã đúng
        if (current < numberAllOrigin && current >= 0) {
            // console.log(1111)
            setNumberSpent((pre) => pre + kq.count);
            // console.log('kq.correct', kq.correct)
            setNumberCorrect((pre) => pre + kq.correct);
        }

        // console.log('type', type)
        playAudio(type);
        if (checkIsImportant(gplxCode, questions[current].no)) {
            if (type !== 'right') { // tức SAI
                setImportant((pre) => ({
                    ...pre,
                    spent: pre.spent + 1,
                    wrong: pre.wrong + 1
                }))
            } else {
                setImportant((pre) => ({
                    ...pre,
                    spent: pre.spent + 1
                }))
            }
        }
    }

    function playAudio(type) {
        if (type === 'right') {
            playAudioRight();
        } else if (type === 'wrong') {
            playAudioWrong();
        } else {
            playAudioNormal();
        }
    }

    function handleOnClickExit(e) {
        navigate(`/?lesson=${lessonId}&exercise=${exerciseId}`);
    }

    function callBackOnComplete() {
        console.log('important', important)
        console.log('numberCorrect', numberCorrect)
        console.log('getConfigForTest(gplxCode).min', getConfigForTest(gplxCode).min)
        if (important.spent > 0 && important.wrong === 0 && numberCorrect >= getConfigForTest(gplxCode).min) {
            if (testResult === 'UNKNOWN') {
                setTestResult('PASS');
            }
        } else {
            if (testResult === 'UNKNOWN') {
                setTestResult('FAIL');
            }
        }
    }

    // Mỗi lần thay đổi mảng câu hỏi
    useEffect(() => {
        if (testResult === 'PASS')
            toast.success('ĐẬU RỒI.');
        if (testResult === 'FAIL')
            toast.error('RỚT RỒI.');
    }, [testResult]);

    // Mỗi lần thay đổi mảng câu hỏi
    useEffect(() => {
        // tính lại tổng số câu
        setNumberAll(calcQuantityOfQuestion(questions));
    }, [questions]);

    useEffect(() => {
        if (timeDone)
            callBackOnComplete();
    }, [timeDone]);

    // load dữ liệu dựa vào param ở uri
    useEffect(() => {
        quizApi
            .getExercise({
                bookId: bookId,
                lessonId: lessonId,
                id: exerciseId,
            })
            .then((res) => {
                setFirst(false);
                // console.log('res', res.data);
                if (res && res.data.code === '00') {
                    // toast.success('Load dữ liệu thành công');
                    let rs;
                    if (!res.data.data.shuffle)
                        rs = res.data.data.questions;
                    else
                        rs = shuffleArray(res.data.data.questions);
                    // console.log('rs', rs)
                    setQuestions(rs);
                    setAudioMap(res.data.data.audioMap);
                    const num = calcQuantityOfQuestion(rs);
                    setNumberAll(num);
                    setNumberAllOrigin(num);
                } else {
                    toast.error(JSON.stringify(res.data));
                }
            })
            .catch((error) => {
                console.log(error);
                setFirst(false);
            });
    }, [bookId, lessonId, exerciseId]);

    // bắt sự kiện resize trình duyệt
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return first ? (
        <div id="loading">
            <BarLoader color="green" />
        </div>
    ) : questions.length <= 0 ? (
        <div>No Data</div>
    ) : (
        <main
            className={styles.wrapper}
            style={{
                height: `${viewportHeight}px`,
            }}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <IconButton
                        onClick={handleOnClickExit}
                        className={clsx(styles.btnExit)}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </IconButton>
                    <ProgressBar
                        percent={(numberSpent / numberAll) * 100}
                        className={clsx(styles.bar)}
                    ></ProgressBar>
                    <div className={clsx(styles.all)}>{numberAll}</div>
                </div>
                {isTest && <div className={styles.timer}>
                    <Countdown date={targetTime}
                        renderer={({ minutes, seconds }) => {
                            if (timeDone) {
                                return <span>Hết giờ</span>;
                            } else {
                                // Render a countdown
                                return <span>
                                    {String(minutes).padStart(2, "0")}:
                                    {String(seconds).padStart(2, "0")}
                                </span>;
                            }
                        }}
                        onComplete={() => setTimeDone(true)}
                    />
                </div>}
                {/* <div className={styles.subHeader}>
                    <div>
                        {lessonId ? 'Exercise ' + lessonId : 'Exercise: All '}
                    </div>
                    <div>
                        {lessonId && exerciseId
                            ? 'Exercise ' + exerciseId
                            : 'Exercise: All '}
                    </div>
                </div> */}
                <div className={clsx(styles.scrollable)}>
                    {/* group which this question belongs to */}
                    {/* <div className={styles.group}>
                        <div className={clsx(styles.tittle)}>
                            {questions[current].group}
                        </div>
                    </div> */}
                    {/* general requirement */}
                    <div className={styles.require}>
                        <div className={clsx(styles.tittle)}>
                            {questions[current].tittle}
                            {checkIsImportant(gplxCode, questions[current].no) && " (QUAN TRỌNG)"}
                        </div>
                    </div>

                    {/* question content: include anwser */}
                    <div className={styles.questionWrapper}>
                        {questions[current].type === 'matching' ? (
                            <MatchQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}

                            />
                        ) : questions[current].type === 'multiple-choices' ? (
                            <MultipleChoicesQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                            />
                        ) : questions[current].type === 'arrange' ? (
                            <ArrangeQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                                audioMap={audioMap}
                                handlePlay={handlePlay}
                                handlePlayByWords={handlePlayByWords}
                                handleStop={handleStop}
                            />
                        ) : questions[current].type === 'blank-listening' ? (
                            <BlankQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                                audioMap={audioMap}
                                handlePlay={handlePlay}
                                handlePlayByWords={handlePlayByWords}
                                handleStop={handleStop}
                            // setUrls={setUrls}
                            />
                        ) : questions[current].type === 'arrange-listening' ? (
                            <ArrangeQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                                audioMap={audioMap}
                                handlePlay={handlePlay}
                                handlePlayByWords={handlePlayByWords}
                                handleStop={handleStop}
                            />
                        ) : questions[current].type === 'matching-listening' ? (
                            <MatchQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                                audioMap={audioMap}
                                handlePlay={handlePlay}
                                // handlePlayByWords={handlePlayByWords}
                                handleStop={handleStop}
                            />
                        ) : questions[current].type ===
                            'multiple-choices-listening' ? (
                            <MultipleChoicesQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                                audioMap={audioMap}
                                handlePlay={handlePlay}
                                // handlePlayByWords={handlePlayByWords}
                                handleStop={handleStop}
                            />
                        ) : questions[current].type ===
                            'crossword' ? (
                            <CrosswordQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                            // audioMap={audioMap}
                            // handlePlay={handlePlay}
                            // handlePlayByWords={handlePlayByWords}
                            // handleStop={handleStop}
                            />
                        ) : (
                            <BlankQuestion
                                question={questions[current]}
                                // ref={questionRef}
                                updateResult={updateResult}
                                notiCompleteAnAnswer={notiCompleteAnAnswer}
                            />
                        )}
                    </div>
                </div>
            </div>
            <FireworksEffect trigger={streak === 5 && !isTest} message="🎯 5 câu đúng liên tiếp!" />
            <FireworksEffect trigger={streak === 10 && !isTest} message="🎯 10 câu đúng liên tiếp!" />
        </main>
    );
}
export default Exercise;

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
